import { create } from "zustand";
const projectsList = (set) => ({
    projectsList: null,
    setProjectsList: (projectsList) => {
        set(() => ({ projectsList }));
    }
});
const useProjectsListStore = create(projectsList);
export default useProjectsListStore;
